/*
 * @Author: cc
 * @Date: 2019-11-25 12:52:23
 * @LastEditTime: 2020-07-22 15:14:43
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\MC\notice\noticeRouter.js
 * @Description: 
 */ 
/**
 * 消息中心-通知公告路由
 * Bai.Zhiming
 * 2019-6-25
 */
angular.module('messageCNoticeRouterModule', [])
    . config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('front.mc.notice', {
            url: '/notice',
            views: {
                'main@front.mc': {
                    template: '<div class="message_c_notice" ui-view="main"></div>',
                }
            }
        }).state('front.mc.notice.noticeinfo', {
            url: '/noticeinfo/:id',
            views: {
                'main@front.mc.notice': {
                    templateUrl: './MC/notice/noticeInfo/noticeInfo_tpl.html',
                    controller: 'noticeInfoCtrl'
                }
            }
        }).state('front.mc.notice.typeconfigadmin', {
            url: '/typeconfigadmin',
            views: {
                'main@front.mc.notice': {
                    templateUrl: './MC/notice/typeConfigAdmin/typeConfigAdmin_tpl.html',
                    controller: 'typeConfigAdminCtrl'
                }
            }
        }).state('front.mc.notice.typeconfigtadmin', {
            url: '/typeconfigtadmin',
            views: {
                'main@front.mc.notice': {
                    templateUrl: './MC/notice/typeConfigTAdmin/typeConfigTAdmin_tpl.html',
                    controller: 'typeConfigTAdminCtrl'
                }
            }
        });
    }]);
